import { MediaType } from '@giphy/js-fetch-api'
import React, { FC, useState } from 'react'
import useSameObjectRef from 'shared/hooks/use-same-ref'
import { SearchOptionsPageData } from 'shared/types/page-data'
import SearchOptionsContext from './search-options'

type Props = {
    initialSearch?: SearchOptionsPageData
}

const SearchOptionsManager: FC<Props> = ({ children, initialSearch }) => {
    const [type, setType] = useState<MediaType>(initialSearch?.isSticker ? 'stickers' : 'gifs')
    const [sort, setSort] = useState<'recent' | 'relevant' | undefined>(initialSearch?.sorting)
    const [searchResponseId, setSearchResponseId] = useState('')
    const [clipSearchResponseId, setClipSearchResponseId] = useState('')
    const contextValue = useSameObjectRef({
        type,
        sort,
        setSort,
        setType,
        searchResponseId,
        setSearchResponseId,
        clipSearchResponseId,
        setClipSearchResponseId,
    })
    return <SearchOptionsContext.Provider value={contextValue}>{children}</SearchOptionsContext.Provider>
}

export default SearchOptionsManager
